import { InsuranceCarrierEnum } from "./insurance";

export const ACP_ELIGIBLE_INSURERS = [
  InsuranceCarrierEnum.CDPHP_MEDICAID,
  InsuranceCarrierEnum.CDPHP,
  InsuranceCarrierEnum.MVP_HEALTHCARE,
  InsuranceCarrierEnum.MVP_MEDICAID,
  InsuranceCarrierEnum.MVP,
  InsuranceCarrierEnum.OTHER,
] as const;
